<div *ngIf="isLoggedIn" class="header-container">
  <p-menubar [model]="menuItems" [styleClass]="getMenuBarStyle()">
    <ng-template pTemplate="start">
      <a *ngIf="!smallScreen" href="{{clientUrl}}" target="_blank" title="Go to {{clientName}} company site">
        <img src="{{clientLogo}}" height="40px" class="p-m-2"/>
      </a>
      <a *ngIf="smallScreen" href="/home" target="_self" title="Goto home page">
        <img src="{{clientLogo}}" height="40px" class="p-m-2"/>
      </a>
    </ng-template>
    <ng-template pTemplate="end">
      <p-avatar
              label="{{getUserInitial()}}"
              styleClass="p-mr-2"
              size="large"
              [style]="{'background-color':'#2196F3', 'color': '#ffffff'}"
              shape="circle"
              (click)="showProfileSideBar = true"></p-avatar>            
    </ng-template>
  </p-menubar>

  <section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
      <defs>
        <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z">
      </path></defs>
      <g class="wave1">
        <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)">
      </use></g>
      <g class="wave2">
        <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)">
      </use></g>
      <g class="wave3">
        <use xlink:href="#wave-path" x="50" y="9" fill="#fff">
      </use></g>
    </svg>
  </section>  

  <p-sidebar [(visible)]="showProfileSideBar" position="right" [baseZIndex]="10000" 
            [showCloseIcon]="false"
            class="user-profile-sidebar p-component">
    <div class="p-text-center">
      <p-avatar
              label="{{getUserInitial()}}"
              size="xlarge"
              [style]="{'background-color':'#2196F3', 'color': '#ffffff'}"
              shape="circle"
      ></p-avatar>
      <h2>{{getUserFullname()}}</h2>
      <div>{{getUserEmail()}}</div>

      <div class="p-mt-4">
        <h4>You are currently a member of:</h4>

        <p-chip *ngFor="let role of userContext.roles" label="{{role.roleName}}" icon="fas fa-user-tag" 
                styleClass="p-mr-2 p-mb-2 role-chip"></p-chip>
      </div>
    </div>

    <p-divider type="solid"></p-divider>

    <p-menu [model]="userProfileItems" class="user-profile-menu"></p-menu>
  </p-sidebar>
</div>